import { Card, Form } from "react-bootstrap";
import { formatPretty } from "../../helpers/dateHelper";
import CollectiveAdd from "./CollectiveAdd";
import { useEffect } from "react";

function CollectiveInfo(props) {
  useEffect(() => {}, [props.collective]);
  if (!props.collective) {
    return <CollectiveAdd {...props} />;
  }

  return (
    <Card>
      <Card.Header>
        <Card.Title as="h4">Family мэдээлэл</Card.Title>
      </Card.Header>
      <Card.Body>
        <Form>
          <Form.Group>
            <label>UA Group ID</label>
            <Form.Control
              value={props.collective.family_id}
              placeholder="Овог"
              type="text"
              disabled
            ></Form.Control>
          </Form.Group>
          <Form.Group>
            <label>Family Нэр</label>
            <Form.Control
              value={props.collective.family_name || ""}
              placeholder="Овог"
              type="text"
              disabled
            ></Form.Control>
          </Form.Group>
          <Form.Group>
            <label>Үүссэн Огноо</label>
            <Form.Control
              value={formatPretty(props.collective.created_at) || ""}
              placeholder="Овог"
              type="text"
              disabled
            ></Form.Control>
          </Form.Group>
          <Form.Group>
            <label>Дансны үлдэгдэл</label>
            <Form.Control
              value={props.collective.balance || 0}
              placeholder="Овог"
              type="text"
              disabled
            ></Form.Control>
          </Form.Group>
        </Form>
      </Card.Body>
    </Card>
  );
}
export default CollectiveInfo;
